import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment';
import 'moment-timezone';
import 'moment-duration-format';
import { useParams } from 'react-router-dom'
import { scoreCardActivityAPI } from '../../services/api/scorecard-activity'
import { AuthContext } from '../../store/auth-context'
import { ScoreCardContext } from '../../store/scorecard-context'
import { getCookie } from '../../utils/common'
import Spinner from '../UI/Spinner'
import styles from './AllReviews.module.css'


const AllReviews = ({rightPanelActiveComponent, toggleRightPanelComponent, id}: any) => {

    const scorecardCtx = useContext(ScoreCardContext)
    const authCtx = useContext(AuthContext)
    const [data, setData] = useState<Array<{[key: string]: any}>>([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        if(rightPanelActiveComponent === 'allreviews') {
            getReviews()
        }
    }, [rightPanelActiveComponent])

    const getReviews = () => {
        const tenantSlug = getCookie('current_tenant')
        scoreCardActivityAPI(tenantSlug).getSingle?.(id)
            .then(response => {
                // we only need Ai analysed / QA analysted reviews
                let filteredData = response.filter((res:any) => {
                    return ((res.review_by == "AI" && res.ai_analysed) || (res.review_by != "AI"))
                })
                setData(filteredData)
                setIsLoading(false)
            })
            .catch((err: any) => {
                if (err.response) {
                    console.log(err.response)
                } else if (err.request) {
                    console.log(err.request)
                } else {
                    console.log(err)
                }
            })
    }

    const getReviewsUI = data && data.length && data.map((review, i) => {
        return  <div className={`${styles.reviewerDetails} d-flex justify-content-between p-3 mt-3`} key={`review-${i}`}>
                    <div className={styles.createdBy}>
                        <h6>{`${review.review_by ? (review.review_by == 'AI' ? 'Nytro.ai' : review.review_by ) : ''}`}</h6>
                        {
                            <p>{moment.tz(review.created_at, "UTC").format('MM/DD/YYYY')}</p>
                        }
                    </div>
                    <div className="d-flex align-items-start">
                        {
                            <span className={`${styles.reviewedScore}`}>
                                Score:
                                {
                                    review?.ai_analysed ?
                                        (
                                            review?.review_score < 0 ? 
                                                '0%' : 
                                                `${Math.round(review?.review_score)}%`
                                        ):
                                        (
                                            review?.review_score ? 
                                                (
                                                    review?.review_score < 0 ? 
                                                        '0%' : 
                                                        `${Math.round(review?.review_score)}%`
                                                ) 
                                                : '-'
                                        )
                                }
                            </span>
                        }
                    </div>
                </div>
    })

    return (
        <div className={styles.allreviewsContainer} hidden={rightPanelActiveComponent === 'allreviews' ? false : true }>
            <div className={`d-flex justify-content-between mb-2 ${styles.scoreCardHeader}`}>
                <h5 className={styles.containerTitle}>Reviews</h5>
                <span onClick={() => toggleRightPanelComponent()}><i className="bi bi-x-square fs-5"></i></span>
            </div>
            {
                isLoading ?
                    <div className="d-flex justify-content-center my-5">
                        <Spinner size="md" />
                    </div>
                    :
                    <div>
                        { data.length > 0 ? getReviewsUI : 'No Reviews Yet!' }
                    </div>
            }
        </div>
    )
}

export default AllReviews
